
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");














var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
function $ced39bfea5ef5993$export$9f275aff884e1431(t0) {
    const $ = (0, $frIzR.c)(16);
    const { extension: extension, onClick: onClick, isLoading: isLoading } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== onClick) {
        t1 = (e)=>{
            e.stopPropagation();
            onClick(extension);
        };
        $[0] = extension;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClickCB = t1;
    const t2 = extension.id;
    let t3;
    if ($[3] !== extension) {
        t3 = (0, $9fBoq.extensionTitle)(extension);
        $[3] = extension;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }));
        $[5] = isLoading;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isLoading || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, t3, t4);
        $[7] = isLoading;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== extension.id || $[12] !== isLoading || $[13] !== onClickCB || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
            id: t2,
            isDisabled: isLoading,
            label: t5,
            onClick: onClickCB
        });
        $[11] = extension.id;
        $[12] = isLoading;
        $[13] = onClickCB;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
}
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
function $0c33e41081c1500e$var$ForgeUIExtensionLoader(t0) {
    const $ = (0, $frIzR.c)(33);
    const { extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    let t2;
    let t3;
    if ($[0] !== setIsCloseMenuDisabled) {
        t2 = ()=>{
            setIsCloseMenuDisabled(true);
            return ()=>{
                setIsCloseMenuDisabled(false);
            };
        };
        t3 = [
            setIsCloseMenuDisabled
        ];
        $[0] = setIsCloseMenuDisabled;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[3] !== activationId || $[4] !== contentId || $[5] !== createAnalyticsEvent || $[6] !== experienceTracker || $[7] !== extension || $[8] !== onLoadComplete || $[9] !== routeName || $[10] !== spaceAlias || $[11] !== spaceId) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME
            });
            onLoadComplete();
            const appId = (0, $8a9Dm.getAppId)(extension);
            const analyticEvent = createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                        moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            });
            analyticEvent.fire();
        };
        $[3] = activationId;
        $[4] = contentId;
        $[5] = createAnalyticsEvent;
        $[6] = experienceTracker;
        $[7] = extension;
        $[8] = onLoadComplete;
        $[9] = routeName;
        $[10] = spaceAlias;
        $[11] = spaceId;
        $[12] = t4;
    } else t4 = $[12];
    const onInitialRender = t4;
    if (!spaceKey) return null;
    const t5 = extension.id;
    const t6 = isLivePage ? "live" : null;
    let t7;
    if ($[13] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[13] = routeName;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== t6 || $[17] !== t7) {
        t8 = {
            id: contentId,
            subtype: t6,
            type: t7
        };
        $[15] = contentId;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[19] !== spaceId || $[20] !== t9) {
        t10 = {
            key: t9,
            id: spaceId
        };
        $[19] = spaceId;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            content: t8,
            space: t10
        };
        $[22] = t10;
        $[23] = t8;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== onClose || $[26] !== setIsCloseMenuDisabled) {
        t12 = ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        };
        $[25] = onClose;
        $[26] = setIsCloseMenuDisabled;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== extension || $[29] !== onInitialRender || $[30] !== t11 || $[31] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp), {
            key: t5,
            app: extension,
            extensionData: t11,
            onInitialRender: onInitialRender,
            onTearDown: t12
        }));
        $[28] = extension;
        $[29] = onInitialRender;
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
}
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("04ghB"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("1yZJt"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("h64Ig"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("a4iE9"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("yxSVC"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("9i5Ug"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("1V3vQ"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("3NBY9"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("92bSL"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("2aVaL"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("bGOXu"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("9xm3I"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("04ghB", function(module, exports) {

let $00cd014824bf1b23$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $00cd014824bf1b23$var$load("2YffH"),
    $00cd014824bf1b23$var$load("8Kivm"),
    $00cd014824bf1b23$var$load("b99Vc"),
    $00cd014824bf1b23$var$load("lqFMg"),
    $00cd014824bf1b23$var$load("9cgFg"),
    $00cd014824bf1b23$var$load("9gEhX"),
    $00cd014824bf1b23$var$load("iQ0Jm"),
    $00cd014824bf1b23$var$load("6lUA3"),
    $00cd014824bf1b23$var$load("8Tr2S"),
    $00cd014824bf1b23$var$load("eBRUf"),
    $00cd014824bf1b23$var$load("d63le"),
    $00cd014824bf1b23$var$load("l8GL7"),
    $00cd014824bf1b23$var$load("h4Nf7"),
    $00cd014824bf1b23$var$load("7f9Fz"),
    $00cd014824bf1b23$var$load("8YSo7"),
    $00cd014824bf1b23$var$load("k6h1Q"),
    $00cd014824bf1b23$var$load("lz6Bt"),
    $00cd014824bf1b23$var$load("76iIp"),
    $00cd014824bf1b23$var$load("az9CK"),
    $00cd014824bf1b23$var$load("g9CVe"),
    $00cd014824bf1b23$var$load("aeEUI"),
    $00cd014824bf1b23$var$load("eY3St"),
    $00cd014824bf1b23$var$load("bkd4T"),
    $00cd014824bf1b23$var$load("6wr18"),
    $00cd014824bf1b23$var$load("kjZZD"),
    $00cd014824bf1b23$var$load("Wowvf"),
    $00cd014824bf1b23$var$load("kHOMt"),
    $00cd014824bf1b23$var$load("dRpV3"),
    $00cd014824bf1b23$var$load("ffEVr"),
    $00cd014824bf1b23$var$load("hhss7"),
    $00cd014824bf1b23$var$load("lvU64"),
    $00cd014824bf1b23$var$load("3DNgt"),
    $00cd014824bf1b23$var$load("681Yn"),
    $00cd014824bf1b23$var$load("3yj56"),
    $00cd014824bf1b23$var$load("6mG00"),
    $00cd014824bf1b23$var$load("jryxA"),
    $00cd014824bf1b23$var$load("dWZbK"),
    $00cd014824bf1b23$var$load("iqKwT"),
    $00cd014824bf1b23$var$load("kULV9"),
    $00cd014824bf1b23$var$load("jEmf3"),
    $00cd014824bf1b23$var$load("kUbUu"),
    $00cd014824bf1b23$var$load("2PePB"),
    $00cd014824bf1b23$var$load("lnKog"),
    $00cd014824bf1b23$var$load("9ftJe"),
    $00cd014824bf1b23$var$load("h3ABO"),
    $00cd014824bf1b23$var$load("kC80R"),
    $00cd014824bf1b23$var$load("7EorR"),
    $00cd014824bf1b23$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("1yZJt", function(module, exports) {

let $1238da37df5d60b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1238da37df5d60b0$var$load("2YffH"),
    $1238da37df5d60b0$var$load("8Kivm"),
    $1238da37df5d60b0$var$load("b99Vc"),
    $1238da37df5d60b0$var$load("lqFMg"),
    $1238da37df5d60b0$var$load("9cgFg"),
    $1238da37df5d60b0$var$load("9gEhX"),
    $1238da37df5d60b0$var$load("iQ0Jm"),
    $1238da37df5d60b0$var$load("6lUA3"),
    $1238da37df5d60b0$var$load("8Tr2S"),
    $1238da37df5d60b0$var$load("eBRUf"),
    $1238da37df5d60b0$var$load("d63le"),
    $1238da37df5d60b0$var$load("l8GL7"),
    $1238da37df5d60b0$var$load("h4Nf7"),
    $1238da37df5d60b0$var$load("7f9Fz"),
    $1238da37df5d60b0$var$load("8YSo7"),
    $1238da37df5d60b0$var$load("k6h1Q"),
    $1238da37df5d60b0$var$load("lz6Bt"),
    $1238da37df5d60b0$var$load("76iIp"),
    $1238da37df5d60b0$var$load("az9CK"),
    $1238da37df5d60b0$var$load("g9CVe"),
    $1238da37df5d60b0$var$load("aeEUI"),
    $1238da37df5d60b0$var$load("eY3St"),
    $1238da37df5d60b0$var$load("bkd4T"),
    $1238da37df5d60b0$var$load("6wr18"),
    $1238da37df5d60b0$var$load("kjZZD"),
    $1238da37df5d60b0$var$load("Wowvf"),
    $1238da37df5d60b0$var$load("kHOMt"),
    $1238da37df5d60b0$var$load("dRpV3"),
    $1238da37df5d60b0$var$load("ffEVr"),
    $1238da37df5d60b0$var$load("hhss7"),
    $1238da37df5d60b0$var$load("lvU64"),
    $1238da37df5d60b0$var$load("3DNgt"),
    $1238da37df5d60b0$var$load("681Yn"),
    $1238da37df5d60b0$var$load("3yj56"),
    $1238da37df5d60b0$var$load("6mG00"),
    $1238da37df5d60b0$var$load("jryxA"),
    $1238da37df5d60b0$var$load("dWZbK"),
    $1238da37df5d60b0$var$load("iqKwT"),
    $1238da37df5d60b0$var$load("kULV9"),
    $1238da37df5d60b0$var$load("jEmf3"),
    $1238da37df5d60b0$var$load("kUbUu"),
    $1238da37df5d60b0$var$load("2PePB"),
    $1238da37df5d60b0$var$load("lnKog"),
    $1238da37df5d60b0$var$load("9ftJe"),
    $1238da37df5d60b0$var$load("h3ABO"),
    $1238da37df5d60b0$var$load("kC80R"),
    $1238da37df5d60b0$var$load("7EorR"),
    $1238da37df5d60b0$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("h64Ig", function(module, exports) {

let $c726a718a3195a0d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c726a718a3195a0d$var$load("2YffH"),
    $c726a718a3195a0d$var$load("8Kivm"),
    $c726a718a3195a0d$var$load("b99Vc"),
    $c726a718a3195a0d$var$load("lqFMg"),
    $c726a718a3195a0d$var$load("9cgFg"),
    $c726a718a3195a0d$var$load("9gEhX"),
    $c726a718a3195a0d$var$load("iQ0Jm"),
    $c726a718a3195a0d$var$load("6lUA3"),
    $c726a718a3195a0d$var$load("8Tr2S"),
    $c726a718a3195a0d$var$load("eBRUf"),
    $c726a718a3195a0d$var$load("d63le"),
    $c726a718a3195a0d$var$load("l8GL7"),
    $c726a718a3195a0d$var$load("h4Nf7"),
    $c726a718a3195a0d$var$load("7f9Fz"),
    $c726a718a3195a0d$var$load("8YSo7"),
    $c726a718a3195a0d$var$load("k6h1Q"),
    $c726a718a3195a0d$var$load("lz6Bt"),
    $c726a718a3195a0d$var$load("76iIp"),
    $c726a718a3195a0d$var$load("az9CK"),
    $c726a718a3195a0d$var$load("g9CVe"),
    $c726a718a3195a0d$var$load("aeEUI"),
    $c726a718a3195a0d$var$load("eY3St"),
    $c726a718a3195a0d$var$load("bkd4T"),
    $c726a718a3195a0d$var$load("6wr18"),
    $c726a718a3195a0d$var$load("kjZZD"),
    $c726a718a3195a0d$var$load("Wowvf"),
    $c726a718a3195a0d$var$load("kHOMt"),
    $c726a718a3195a0d$var$load("dRpV3"),
    $c726a718a3195a0d$var$load("ffEVr"),
    $c726a718a3195a0d$var$load("hhss7"),
    $c726a718a3195a0d$var$load("lvU64"),
    $c726a718a3195a0d$var$load("3DNgt"),
    $c726a718a3195a0d$var$load("681Yn"),
    $c726a718a3195a0d$var$load("3yj56"),
    $c726a718a3195a0d$var$load("6mG00"),
    $c726a718a3195a0d$var$load("jryxA"),
    $c726a718a3195a0d$var$load("dWZbK"),
    $c726a718a3195a0d$var$load("iqKwT"),
    $c726a718a3195a0d$var$load("kULV9"),
    $c726a718a3195a0d$var$load("jEmf3"),
    $c726a718a3195a0d$var$load("kUbUu"),
    $c726a718a3195a0d$var$load("2PePB"),
    $c726a718a3195a0d$var$load("lnKog"),
    $c726a718a3195a0d$var$load("9ftJe"),
    $c726a718a3195a0d$var$load("h3ABO"),
    $c726a718a3195a0d$var$load("kC80R"),
    $c726a718a3195a0d$var$load("7EorR"),
    $c726a718a3195a0d$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("a4iE9", function(module, exports) {

let $7548bdf236bac92c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7548bdf236bac92c$var$load("76iIp"),
    $7548bdf236bac92c$var$load("az9CK"),
    $7548bdf236bac92c$var$load("2YffH"),
    $7548bdf236bac92c$var$load("b99Vc"),
    $7548bdf236bac92c$var$load("lqFMg"),
    $7548bdf236bac92c$var$load("2PePB"),
    $7548bdf236bac92c$var$load("9cgFg"),
    $7548bdf236bac92c$var$load("9gEhX"),
    $7548bdf236bac92c$var$load("6lUA3"),
    $7548bdf236bac92c$var$load("eBRUf"),
    $7548bdf236bac92c$var$load("d63le"),
    $7548bdf236bac92c$var$load("l8GL7"),
    $7548bdf236bac92c$var$load("h4Nf7"),
    $7548bdf236bac92c$var$load("7f9Fz"),
    $7548bdf236bac92c$var$load("8YSo7"),
    $7548bdf236bac92c$var$load("k6h1Q"),
    $7548bdf236bac92c$var$load("lz6Bt"),
    $7548bdf236bac92c$var$load("g9CVe"),
    $7548bdf236bac92c$var$load("aeEUI"),
    $7548bdf236bac92c$var$load("eY3St"),
    $7548bdf236bac92c$var$load("bkd4T"),
    $7548bdf236bac92c$var$load("6wr18"),
    $7548bdf236bac92c$var$load("kjZZD"),
    $7548bdf236bac92c$var$load("Wowvf"),
    $7548bdf236bac92c$var$load("kHOMt"),
    $7548bdf236bac92c$var$load("dRpV3"),
    $7548bdf236bac92c$var$load("ffEVr"),
    $7548bdf236bac92c$var$load("hhss7"),
    $7548bdf236bac92c$var$load("lvU64"),
    $7548bdf236bac92c$var$load("3DNgt"),
    $7548bdf236bac92c$var$load("681Yn"),
    $7548bdf236bac92c$var$load("3yj56"),
    $7548bdf236bac92c$var$load("6mG00"),
    $7548bdf236bac92c$var$load("jryxA"),
    $7548bdf236bac92c$var$load("dWZbK"),
    $7548bdf236bac92c$var$load("iqKwT"),
    $7548bdf236bac92c$var$load("kULV9"),
    $7548bdf236bac92c$var$load("jEmf3"),
    $7548bdf236bac92c$var$load("kUbUu"),
    $7548bdf236bac92c$var$load("9ftJe"),
    $7548bdf236bac92c$var$load("h3ABO"),
    $7548bdf236bac92c$var$load("kC80R"),
    $7548bdf236bac92c$var$load("7EorR"),
    $7548bdf236bac92c$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("yxSVC", function(module, exports) {

let $067d75ef14b90d69$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $067d75ef14b90d69$var$load("76iIp"),
    $067d75ef14b90d69$var$load("az9CK"),
    $067d75ef14b90d69$var$load("2YffH"),
    $067d75ef14b90d69$var$load("b99Vc"),
    $067d75ef14b90d69$var$load("lqFMg"),
    $067d75ef14b90d69$var$load("2PePB"),
    $067d75ef14b90d69$var$load("9cgFg"),
    $067d75ef14b90d69$var$load("9gEhX"),
    $067d75ef14b90d69$var$load("6lUA3"),
    $067d75ef14b90d69$var$load("eBRUf"),
    $067d75ef14b90d69$var$load("d63le"),
    $067d75ef14b90d69$var$load("l8GL7"),
    $067d75ef14b90d69$var$load("h4Nf7"),
    $067d75ef14b90d69$var$load("7f9Fz"),
    $067d75ef14b90d69$var$load("8YSo7"),
    $067d75ef14b90d69$var$load("k6h1Q"),
    $067d75ef14b90d69$var$load("lz6Bt"),
    $067d75ef14b90d69$var$load("g9CVe"),
    $067d75ef14b90d69$var$load("aeEUI"),
    $067d75ef14b90d69$var$load("eY3St"),
    $067d75ef14b90d69$var$load("bkd4T"),
    $067d75ef14b90d69$var$load("6wr18"),
    $067d75ef14b90d69$var$load("kjZZD"),
    $067d75ef14b90d69$var$load("Wowvf"),
    $067d75ef14b90d69$var$load("kHOMt"),
    $067d75ef14b90d69$var$load("dRpV3"),
    $067d75ef14b90d69$var$load("ffEVr"),
    $067d75ef14b90d69$var$load("hhss7"),
    $067d75ef14b90d69$var$load("lvU64"),
    $067d75ef14b90d69$var$load("3DNgt"),
    $067d75ef14b90d69$var$load("681Yn"),
    $067d75ef14b90d69$var$load("3yj56"),
    $067d75ef14b90d69$var$load("6mG00"),
    $067d75ef14b90d69$var$load("jryxA"),
    $067d75ef14b90d69$var$load("dWZbK"),
    $067d75ef14b90d69$var$load("iqKwT"),
    $067d75ef14b90d69$var$load("kULV9"),
    $067d75ef14b90d69$var$load("jEmf3"),
    $067d75ef14b90d69$var$load("kUbUu"),
    $067d75ef14b90d69$var$load("9ftJe"),
    $067d75ef14b90d69$var$load("h3ABO"),
    $067d75ef14b90d69$var$load("kC80R"),
    $067d75ef14b90d69$var$load("7EorR"),
    $067d75ef14b90d69$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("9i5Ug", function(module, exports) {

let $6c3a6067dea9c074$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6c3a6067dea9c074$var$load("76iIp"),
    $6c3a6067dea9c074$var$load("az9CK"),
    $6c3a6067dea9c074$var$load("2YffH"),
    $6c3a6067dea9c074$var$load("b99Vc"),
    $6c3a6067dea9c074$var$load("lqFMg"),
    $6c3a6067dea9c074$var$load("2PePB"),
    $6c3a6067dea9c074$var$load("9cgFg"),
    $6c3a6067dea9c074$var$load("9gEhX"),
    $6c3a6067dea9c074$var$load("6lUA3"),
    $6c3a6067dea9c074$var$load("eBRUf"),
    $6c3a6067dea9c074$var$load("d63le"),
    $6c3a6067dea9c074$var$load("l8GL7"),
    $6c3a6067dea9c074$var$load("h4Nf7"),
    $6c3a6067dea9c074$var$load("7f9Fz"),
    $6c3a6067dea9c074$var$load("8YSo7"),
    $6c3a6067dea9c074$var$load("k6h1Q"),
    $6c3a6067dea9c074$var$load("lz6Bt"),
    $6c3a6067dea9c074$var$load("g9CVe"),
    $6c3a6067dea9c074$var$load("aeEUI"),
    $6c3a6067dea9c074$var$load("eY3St"),
    $6c3a6067dea9c074$var$load("bkd4T"),
    $6c3a6067dea9c074$var$load("6wr18"),
    $6c3a6067dea9c074$var$load("kjZZD"),
    $6c3a6067dea9c074$var$load("Wowvf"),
    $6c3a6067dea9c074$var$load("kHOMt"),
    $6c3a6067dea9c074$var$load("dRpV3"),
    $6c3a6067dea9c074$var$load("ffEVr"),
    $6c3a6067dea9c074$var$load("hhss7"),
    $6c3a6067dea9c074$var$load("lvU64"),
    $6c3a6067dea9c074$var$load("3DNgt"),
    $6c3a6067dea9c074$var$load("681Yn"),
    $6c3a6067dea9c074$var$load("3yj56"),
    $6c3a6067dea9c074$var$load("6mG00"),
    $6c3a6067dea9c074$var$load("jryxA"),
    $6c3a6067dea9c074$var$load("dWZbK"),
    $6c3a6067dea9c074$var$load("iqKwT"),
    $6c3a6067dea9c074$var$load("kULV9"),
    $6c3a6067dea9c074$var$load("jEmf3"),
    $6c3a6067dea9c074$var$load("kUbUu"),
    $6c3a6067dea9c074$var$load("9ftJe"),
    $6c3a6067dea9c074$var$load("h3ABO"),
    $6c3a6067dea9c074$var$load("kC80R"),
    $6c3a6067dea9c074$var$load("7EorR"),
    $6c3a6067dea9c074$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("1V3vQ", function(module, exports) {

let $165dd6da14745aab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $165dd6da14745aab$var$load("76iIp"),
    $165dd6da14745aab$var$load("az9CK"),
    $165dd6da14745aab$var$load("2YffH"),
    $165dd6da14745aab$var$load("b99Vc"),
    $165dd6da14745aab$var$load("lqFMg"),
    $165dd6da14745aab$var$load("9cgFg"),
    $165dd6da14745aab$var$load("9gEhX"),
    $165dd6da14745aab$var$load("6lUA3"),
    $165dd6da14745aab$var$load("eBRUf"),
    $165dd6da14745aab$var$load("d63le"),
    $165dd6da14745aab$var$load("l8GL7"),
    $165dd6da14745aab$var$load("h4Nf7"),
    $165dd6da14745aab$var$load("7f9Fz"),
    $165dd6da14745aab$var$load("8YSo7"),
    $165dd6da14745aab$var$load("k6h1Q"),
    $165dd6da14745aab$var$load("lz6Bt"),
    $165dd6da14745aab$var$load("g9CVe"),
    $165dd6da14745aab$var$load("aeEUI"),
    $165dd6da14745aab$var$load("eY3St"),
    $165dd6da14745aab$var$load("bkd4T"),
    $165dd6da14745aab$var$load("6wr18"),
    $165dd6da14745aab$var$load("kjZZD"),
    $165dd6da14745aab$var$load("Wowvf"),
    $165dd6da14745aab$var$load("kHOMt"),
    $165dd6da14745aab$var$load("dRpV3"),
    $165dd6da14745aab$var$load("ffEVr"),
    $165dd6da14745aab$var$load("hhss7"),
    $165dd6da14745aab$var$load("lvU64"),
    $165dd6da14745aab$var$load("3DNgt"),
    $165dd6da14745aab$var$load("681Yn"),
    $165dd6da14745aab$var$load("3yj56"),
    $165dd6da14745aab$var$load("6mG00"),
    $165dd6da14745aab$var$load("jryxA"),
    $165dd6da14745aab$var$load("dWZbK"),
    $165dd6da14745aab$var$load("iqKwT"),
    $165dd6da14745aab$var$load("kULV9"),
    $165dd6da14745aab$var$load("jEmf3"),
    $165dd6da14745aab$var$load("kUbUu"),
    $165dd6da14745aab$var$load("2PePB"),
    $165dd6da14745aab$var$load("lnKog"),
    $165dd6da14745aab$var$load("9ftJe"),
    $165dd6da14745aab$var$load("h3ABO"),
    $165dd6da14745aab$var$load("kC80R"),
    $165dd6da14745aab$var$load("7EorR"),
    $165dd6da14745aab$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("3NBY9", function(module, exports) {

let $2c436693a7ca4504$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2c436693a7ca4504$var$load("2YffH"),
    $2c436693a7ca4504$var$load("b99Vc"),
    $2c436693a7ca4504$var$load("lqFMg"),
    $2c436693a7ca4504$var$load("9cgFg"),
    $2c436693a7ca4504$var$load("9gEhX"),
    $2c436693a7ca4504$var$load("6lUA3"),
    $2c436693a7ca4504$var$load("8Tr2S"),
    $2c436693a7ca4504$var$load("eBRUf"),
    $2c436693a7ca4504$var$load("d63le"),
    $2c436693a7ca4504$var$load("l8GL7"),
    $2c436693a7ca4504$var$load("h4Nf7"),
    $2c436693a7ca4504$var$load("7f9Fz"),
    $2c436693a7ca4504$var$load("8YSo7"),
    $2c436693a7ca4504$var$load("k6h1Q"),
    $2c436693a7ca4504$var$load("lz6Bt"),
    $2c436693a7ca4504$var$load("76iIp"),
    $2c436693a7ca4504$var$load("az9CK"),
    $2c436693a7ca4504$var$load("g9CVe"),
    $2c436693a7ca4504$var$load("aeEUI"),
    $2c436693a7ca4504$var$load("eY3St"),
    $2c436693a7ca4504$var$load("bkd4T"),
    $2c436693a7ca4504$var$load("6wr18"),
    $2c436693a7ca4504$var$load("kjZZD"),
    $2c436693a7ca4504$var$load("Wowvf"),
    $2c436693a7ca4504$var$load("kHOMt"),
    $2c436693a7ca4504$var$load("dRpV3"),
    $2c436693a7ca4504$var$load("ffEVr"),
    $2c436693a7ca4504$var$load("dTsOE"),
    $2c436693a7ca4504$var$load("hhss7"),
    $2c436693a7ca4504$var$load("lvU64"),
    $2c436693a7ca4504$var$load("3DNgt"),
    $2c436693a7ca4504$var$load("681Yn"),
    $2c436693a7ca4504$var$load("3yj56"),
    $2c436693a7ca4504$var$load("6mG00"),
    $2c436693a7ca4504$var$load("jryxA"),
    $2c436693a7ca4504$var$load("dWZbK"),
    $2c436693a7ca4504$var$load("iqKwT"),
    $2c436693a7ca4504$var$load("kULV9"),
    $2c436693a7ca4504$var$load("jEmf3"),
    $2c436693a7ca4504$var$load("kUbUu"),
    $2c436693a7ca4504$var$load("2PePB"),
    $2c436693a7ca4504$var$load("lnKog"),
    $2c436693a7ca4504$var$load("9ftJe"),
    $2c436693a7ca4504$var$load("h3ABO"),
    $2c436693a7ca4504$var$load("kC80R"),
    $2c436693a7ca4504$var$load("7EorR"),
    $2c436693a7ca4504$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("92bSL", function(module, exports) {

let $693d8483468291ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $693d8483468291ea$var$load("2YffH"),
    $693d8483468291ea$var$load("b99Vc"),
    $693d8483468291ea$var$load("lqFMg"),
    $693d8483468291ea$var$load("9cgFg"),
    $693d8483468291ea$var$load("9gEhX"),
    $693d8483468291ea$var$load("6lUA3"),
    $693d8483468291ea$var$load("8Tr2S"),
    $693d8483468291ea$var$load("eBRUf"),
    $693d8483468291ea$var$load("d63le"),
    $693d8483468291ea$var$load("l8GL7"),
    $693d8483468291ea$var$load("h4Nf7"),
    $693d8483468291ea$var$load("7f9Fz"),
    $693d8483468291ea$var$load("8YSo7"),
    $693d8483468291ea$var$load("k6h1Q"),
    $693d8483468291ea$var$load("lz6Bt"),
    $693d8483468291ea$var$load("76iIp"),
    $693d8483468291ea$var$load("az9CK"),
    $693d8483468291ea$var$load("g9CVe"),
    $693d8483468291ea$var$load("aeEUI"),
    $693d8483468291ea$var$load("eY3St"),
    $693d8483468291ea$var$load("bkd4T"),
    $693d8483468291ea$var$load("6wr18"),
    $693d8483468291ea$var$load("kjZZD"),
    $693d8483468291ea$var$load("Wowvf"),
    $693d8483468291ea$var$load("kHOMt"),
    $693d8483468291ea$var$load("dRpV3"),
    $693d8483468291ea$var$load("ffEVr"),
    $693d8483468291ea$var$load("dTsOE"),
    $693d8483468291ea$var$load("hhss7"),
    $693d8483468291ea$var$load("lvU64"),
    $693d8483468291ea$var$load("3DNgt"),
    $693d8483468291ea$var$load("681Yn"),
    $693d8483468291ea$var$load("3yj56"),
    $693d8483468291ea$var$load("6mG00"),
    $693d8483468291ea$var$load("jryxA"),
    $693d8483468291ea$var$load("dWZbK"),
    $693d8483468291ea$var$load("iqKwT"),
    $693d8483468291ea$var$load("kULV9"),
    $693d8483468291ea$var$load("jEmf3"),
    $693d8483468291ea$var$load("kUbUu"),
    $693d8483468291ea$var$load("2PePB"),
    $693d8483468291ea$var$load("lnKog"),
    $693d8483468291ea$var$load("9ftJe"),
    $693d8483468291ea$var$load("h3ABO"),
    $693d8483468291ea$var$load("kC80R"),
    $693d8483468291ea$var$load("7EorR"),
    $693d8483468291ea$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("2aVaL", function(module, exports) {

let $1958dd3deec6d08c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1958dd3deec6d08c$var$load("76iIp"),
    $1958dd3deec6d08c$var$load("az9CK"),
    $1958dd3deec6d08c$var$load("2YffH"),
    $1958dd3deec6d08c$var$load("b99Vc"),
    $1958dd3deec6d08c$var$load("lqFMg"),
    $1958dd3deec6d08c$var$load("2PePB"),
    $1958dd3deec6d08c$var$load("9cgFg"),
    $1958dd3deec6d08c$var$load("9gEhX"),
    $1958dd3deec6d08c$var$load("6lUA3"),
    $1958dd3deec6d08c$var$load("eBRUf"),
    $1958dd3deec6d08c$var$load("d63le"),
    $1958dd3deec6d08c$var$load("l8GL7"),
    $1958dd3deec6d08c$var$load("h4Nf7"),
    $1958dd3deec6d08c$var$load("7f9Fz"),
    $1958dd3deec6d08c$var$load("8YSo7"),
    $1958dd3deec6d08c$var$load("k6h1Q"),
    $1958dd3deec6d08c$var$load("lz6Bt"),
    $1958dd3deec6d08c$var$load("g9CVe"),
    $1958dd3deec6d08c$var$load("aeEUI"),
    $1958dd3deec6d08c$var$load("eY3St"),
    $1958dd3deec6d08c$var$load("bkd4T"),
    $1958dd3deec6d08c$var$load("6wr18"),
    $1958dd3deec6d08c$var$load("kjZZD"),
    $1958dd3deec6d08c$var$load("Wowvf"),
    $1958dd3deec6d08c$var$load("kHOMt"),
    $1958dd3deec6d08c$var$load("dRpV3"),
    $1958dd3deec6d08c$var$load("ffEVr"),
    $1958dd3deec6d08c$var$load("hhss7"),
    $1958dd3deec6d08c$var$load("lvU64"),
    $1958dd3deec6d08c$var$load("3DNgt"),
    $1958dd3deec6d08c$var$load("681Yn"),
    $1958dd3deec6d08c$var$load("3yj56"),
    $1958dd3deec6d08c$var$load("6mG00"),
    $1958dd3deec6d08c$var$load("jryxA"),
    $1958dd3deec6d08c$var$load("dWZbK"),
    $1958dd3deec6d08c$var$load("iqKwT"),
    $1958dd3deec6d08c$var$load("kULV9"),
    $1958dd3deec6d08c$var$load("jEmf3"),
    $1958dd3deec6d08c$var$load("kUbUu"),
    $1958dd3deec6d08c$var$load("9ftJe"),
    $1958dd3deec6d08c$var$load("h3ABO"),
    $1958dd3deec6d08c$var$load("kC80R"),
    $1958dd3deec6d08c$var$load("7EorR"),
    $1958dd3deec6d08c$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("bGOXu", function(module, exports) {

let $882b253fbbe22ead$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $882b253fbbe22ead$var$load("76iIp"),
    $882b253fbbe22ead$var$load("az9CK"),
    $882b253fbbe22ead$var$load("2YffH"),
    $882b253fbbe22ead$var$load("b99Vc"),
    $882b253fbbe22ead$var$load("lqFMg"),
    $882b253fbbe22ead$var$load("9cgFg"),
    $882b253fbbe22ead$var$load("9gEhX"),
    $882b253fbbe22ead$var$load("6lUA3"),
    $882b253fbbe22ead$var$load("eBRUf"),
    $882b253fbbe22ead$var$load("d63le"),
    $882b253fbbe22ead$var$load("l8GL7"),
    $882b253fbbe22ead$var$load("h4Nf7"),
    $882b253fbbe22ead$var$load("7f9Fz"),
    $882b253fbbe22ead$var$load("8YSo7"),
    $882b253fbbe22ead$var$load("k6h1Q"),
    $882b253fbbe22ead$var$load("lz6Bt"),
    $882b253fbbe22ead$var$load("g9CVe"),
    $882b253fbbe22ead$var$load("aeEUI"),
    $882b253fbbe22ead$var$load("eY3St"),
    $882b253fbbe22ead$var$load("bkd4T"),
    $882b253fbbe22ead$var$load("6wr18"),
    $882b253fbbe22ead$var$load("kjZZD"),
    $882b253fbbe22ead$var$load("Wowvf"),
    $882b253fbbe22ead$var$load("kHOMt"),
    $882b253fbbe22ead$var$load("dRpV3"),
    $882b253fbbe22ead$var$load("ffEVr"),
    $882b253fbbe22ead$var$load("hhss7"),
    $882b253fbbe22ead$var$load("lvU64"),
    $882b253fbbe22ead$var$load("3DNgt"),
    $882b253fbbe22ead$var$load("681Yn"),
    $882b253fbbe22ead$var$load("3yj56"),
    $882b253fbbe22ead$var$load("6mG00"),
    $882b253fbbe22ead$var$load("jryxA"),
    $882b253fbbe22ead$var$load("dWZbK"),
    $882b253fbbe22ead$var$load("iqKwT"),
    $882b253fbbe22ead$var$load("kULV9"),
    $882b253fbbe22ead$var$load("jEmf3"),
    $882b253fbbe22ead$var$load("kUbUu"),
    $882b253fbbe22ead$var$load("2PePB"),
    $882b253fbbe22ead$var$load("lnKog"),
    $882b253fbbe22ead$var$load("9ftJe"),
    $882b253fbbe22ead$var$load("h3ABO"),
    $882b253fbbe22ead$var$load("kC80R"),
    $882b253fbbe22ead$var$load("7EorR"),
    $882b253fbbe22ead$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("9xm3I", function(module, exports) {

let $6f184e9394ed6ba2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6f184e9394ed6ba2$var$load("76iIp"),
    $6f184e9394ed6ba2$var$load("az9CK"),
    $6f184e9394ed6ba2$var$load("2YffH"),
    $6f184e9394ed6ba2$var$load("b99Vc"),
    $6f184e9394ed6ba2$var$load("lqFMg"),
    $6f184e9394ed6ba2$var$load("9cgFg"),
    $6f184e9394ed6ba2$var$load("9gEhX"),
    $6f184e9394ed6ba2$var$load("6lUA3"),
    $6f184e9394ed6ba2$var$load("eBRUf"),
    $6f184e9394ed6ba2$var$load("d63le"),
    $6f184e9394ed6ba2$var$load("l8GL7"),
    $6f184e9394ed6ba2$var$load("h4Nf7"),
    $6f184e9394ed6ba2$var$load("7f9Fz"),
    $6f184e9394ed6ba2$var$load("8YSo7"),
    $6f184e9394ed6ba2$var$load("k6h1Q"),
    $6f184e9394ed6ba2$var$load("lz6Bt"),
    $6f184e9394ed6ba2$var$load("g9CVe"),
    $6f184e9394ed6ba2$var$load("aeEUI"),
    $6f184e9394ed6ba2$var$load("eY3St"),
    $6f184e9394ed6ba2$var$load("bkd4T"),
    $6f184e9394ed6ba2$var$load("6wr18"),
    $6f184e9394ed6ba2$var$load("kjZZD"),
    $6f184e9394ed6ba2$var$load("Wowvf"),
    $6f184e9394ed6ba2$var$load("kHOMt"),
    $6f184e9394ed6ba2$var$load("dRpV3"),
    $6f184e9394ed6ba2$var$load("ffEVr"),
    $6f184e9394ed6ba2$var$load("hhss7"),
    $6f184e9394ed6ba2$var$load("lvU64"),
    $6f184e9394ed6ba2$var$load("3DNgt"),
    $6f184e9394ed6ba2$var$load("681Yn"),
    $6f184e9394ed6ba2$var$load("3yj56"),
    $6f184e9394ed6ba2$var$load("6mG00"),
    $6f184e9394ed6ba2$var$load("jryxA"),
    $6f184e9394ed6ba2$var$load("dWZbK"),
    $6f184e9394ed6ba2$var$load("iqKwT"),
    $6f184e9394ed6ba2$var$load("kULV9"),
    $6f184e9394ed6ba2$var$load("jEmf3"),
    $6f184e9394ed6ba2$var$load("kUbUu"),
    $6f184e9394ed6ba2$var$load("2PePB"),
    $6f184e9394ed6ba2$var$load("lnKog"),
    $6f184e9394ed6ba2$var$load("9ftJe"),
    $6f184e9394ed6ba2$var$load("h3ABO"),
    $6f184e9394ed6ba2$var$load("kC80R"),
    $6f184e9394ed6ba2$var$load("7EorR"),
    $6f184e9394ed6ba2$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey && (0, $9wGTI.fg)('confluence-fe-migrated-custom-content-display-fix')) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("kxN5Y"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("kxN5Y", function(module, exports) {

let $ef4cf9036132d263$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ef4cf9036132d263$var$load("2PePB"),
    $ef4cf9036132d263$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("c54hr", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $1P1Tu.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $9zUhf.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $9zUhf.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $cgtv4.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $8C5kA.default)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.befe9cfb.js.map
